// extracted by mini-css-extract-plugin
export default {"video":"GOhWYb","content":"egAYlc","quote":"x9A4bV"};